import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getImageUrl } from '../../../utils/images'
import { verifyUser } from '../../../service/authServie'
import { onEnterPressed } from '../../../helpers/events'
import { userActions } from '../../../store/userState'
import { useNavigate } from 'react-router-dom'

export const VerfityPage = ({ backButton, email, checkLogin }) => {
  const dispatch = useDispatch()
  const navigator = useNavigate()
  const [input1, setInput1] = useState('')
  const [input2, setInput2] = useState('')
  const [input3, setInput3] = useState('')
  const [input4, setInput4] = useState('')
  const [input5, setInput5] = useState('')
  const [isVerifyDisable, setIsVerifyDisable] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isValidOTP, setIsValidOTP] = useState(true)
  const TimerStatic = useRef(true)

  const [otpTimer, setOTPTimer] = useState(30)

  const changeInputFocus = e => {
    switch (e.target.tabIndex) {
      case 1:
        setInput1(e.target.value)
        break
      case 2:
        setInput2(e.target.value)
        break
      case 3:
        setInput3(e.target.value)
        break
      case 4:
        setInput4(e.target.value)
        break
      case 5:
        setInput5(e.target.value)
        break
      default:
        break
    }
    let index = 0
    if (e.target.value != '') {
      index = e.target.tabIndex + 1
    } else {
      index = e.target.tabIndex - 1
    }
    const input = document.getElementById(`input${index}`)
    if (input) {
      input.focus()
    }
    setIsValidOTP(true)
  }

  const setTimerToDefault = () => {
    checkLogin().then(() => {
      resendOTPTimer()
    })
  }

  const resendOTPTimer = () => {
    setOTPTimer(30)
    const intervalId = setInterval(() => {
      setOTPTimer(otpTimer => {
        if (otpTimer <= 0) {
          clearInterval(intervalId)
          return 0 // Ensure otpTimer doesn't go below 0
        }
        return otpTimer - 1
      })
    }, 1000)
  }

  const resetOTPFields = () => {
    setInput1('')
    setInput2('')
    setInput3('')
    setInput4('')
    setInput5('')
  }

  const verifyOTP = async () => {
    if (input1 && input2 && input3 && input4 && input5) {
      setIsSubmitting(true)
      const otp = `${input1}${input2}${input3}${input4}${input5}`
      const response = await verifyUser(email, otp)
      console.log('myresp', response)
      if (response?.otpVerified) {
        // dispatch(userActions.login(response.Response))
        // navigator("/brand-detail/" +btoa(brand.BrandId))/
        let emiratesId = localStorage.getItem('emiratesID')

        navigator('/show-user-details/' + btoa(emiratesId))
      }
      setIsSubmitting(false)
      setIsValidOTP(false)
      resetOTPFields()
      document.getElementById(`input1`).focus()
    }
  }

  // resendOTPTimer()

  useEffect(() => {
    document.getElementById(`input1`).focus()

    if (TimerStatic.current) {
      resendOTPTimer()
      TimerStatic.current = false
    }
  }, [])

  useEffect(() => {
    if (input1 && input2 && input3 && input4 && input5) {
      return setIsVerifyDisable(false)
    }
    setIsVerifyDisable(true)
  }, [input1, input2, input3, input4, input5])

  return (
    <div className='container-fluid p-5'>
      <div className='pl-4'>
        {/* <a href="#"><img src={getImageUrl("logo-dark.svg")} alt="img" className="w-200p" /></a> */}
        <a onClick={() => backButton()} className='otp-back-btn'>
          <img
          
          
            src={getImageUrl('otp-back.svg')}
            alt='img'
          />
        </a>

        <p className='pl-4  pt-4 mb-0 font-26 font-weight-800'>
          Verify with OTP
        </p>
        <p className='font-12'>
          Please enter the OTP sent to your email address to
          <br />
          verify it.
        </p>
      </div>

      <div className=' pl-4  pt-4 login-right otp'>
        <div className='form-group'>
          <div className='d-flex flex-row justify-content-center'>
            <input
              value={input1}
              tabIndex={1}
              id='input1'
              className='m-2 text-center form-control otp'
              type='text'
              maxLength='1'
              onChange={changeInputFocus}
              onKeyDown={e => onEnterPressed(e, verifyOTP)}
              disabled={isSubmitting}
            />
            <input
              value={input2}
              tabIndex={2}
              id='input2'
              className='m-2 text-center form-control otp'
              type='text'
              maxLength='1'
              onChange={changeInputFocus}
              onKeyDown={e => onEnterPressed(e, verifyOTP)}
              disabled={isSubmitting}
            />
            <input
              value={input3}
              tabIndex={3}
              id='input3'
              className='m-2 text-center form-control otp'
              type='text'
              maxLength='1'
              onChange={changeInputFocus}
              onKeyDown={e => onEnterPressed(e, verifyOTP)}
              disabled={isSubmitting}
            />
            <input
              value={input4}
              tabIndex={4}
              id='input4'
              className='m-2 text-center form-control otp'
              type='text'
              maxLength='1'
              onChange={changeInputFocus}
              onKeyDown={e => onEnterPressed(e, verifyOTP)}
              disabled={isSubmitting}
            />
            <input
              value={input5}
              tabIndex={5}
              id='input5'
              className='m-2 text-center form-control otp'
              type='text'
              maxLength='1'
              onChange={changeInputFocus}
              onKeyDown={e => onEnterPressed(e, verifyOTP)}
              disabled={isSubmitting}
            />
          </div>
        </div>
        {!isValidOTP && (
          <label className='text-danger'>Invalid OTP entered</label>
        )}

        <div className='text-center font-9'>
          <button
            type='button'
            class='btn btn-default  btn-block font-weight-600 rounded-12 py-10 mt-40 mb-4'
            disabled={isVerifyDisable || isSubmitting ? true : false}
            onClick={verifyOTP}
          >
            {' '}
            {isSubmitting ? 'Verifying...' : 'Verify'}
          </button>
          <span className=''>
            Didn’t get OTP?
            <br />
            {otpTimer == 0 ? (
              <span
                className='text-orange pointer font-10 font-weight-700 cursor-pointer'
                onClick={() => {
                  setTimerToDefault()
                  resendOTPTimer()
                }}
              >
                Resend
              </span>
            ) : (
              <span className='font-10 font-weight-700 cursor-not-allowed'>
                Resend in {otpTimer}s
              </span>
            )}
          </span>
        </div>
      </div>
    </div>
  )
}
